import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ModalLegendasMobilePage } from './modal-legendas-mobile.page';

const routes: Routes = [
  {
    path: '',
    component: ModalLegendasMobilePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ModalLegendasMobileRoutingModule {}
